import Cookie from '@templates/App/Cookies.js';

const CookiesPage = {

	cookieName: 'cookies_consent',
	version: 1,
	consent: { CookieFunctional: 1, CookieAnalytical: 0, CookieMarketing: 0 },
	essential: ['CookieFunctional', 'CookieAnalytical'],
	reset: ['CookieAnalytical', 'CookieMarketing'],

	init() {
		this.el = $('[component="CookiePage"]');
		if (!this.el.length) return;

		this.acceptButton = this.el.find('button.accept');
		this.declineButton = this.el.find('button.decline');
		this.resetButton = this.el.find('button.reset');
		this.bind();
		this.checkStatus();
	},

	bind() {
		this.acceptButton.click(function(event) {
			CookiesPage.acceptAllCookies();
		});

		this.declineButton.click(function(event) {
			CookiesPage.acceptEssentialCookies();
		});

		this.resetButton.click(function(event) {
			CookiesPage.resetCookies();
		});

		const pathname = window.location.pathname;

		if (pathname === '/cookies-jp-auto-nitra') {
			$('.euCookies').removeClass('visible');
		}
	},

	loadConsent() {
		let cookie = Cookie.get(this.cookieName);
		if (cookie !== undefined && cookie !== '') {
			let object = JSON.parse(cookie.toString());
			Object.keys(object.consent).forEach((key) => {
				this.setConsent(key, object.consent[key]);
			});
		}
	},

	setConsent(name, value) {
		if (this.consent[name] !== undefined) {
			this.consent[name] = value;
		}
	},

	checkStatus() {
		let allAccepted = true;
		this.loadConsent();

		Object.keys(this.consent).forEach((key) => {
			allAccepted = allAccepted && !!this.consent[key];
			const switcher = this.el.find('[key="' + key + '"], [name="' + key + '"]');
			switcher.attr('on', this.consent[key]);
		});
		return allAccepted;
	},

	setCookie(cookieName, state) {
		this.loadConsent();
		this.setConsent(cookieName, state);
		this.cookiesSave(this.consent, false);
		this.el.find('[key="' + cookieName + '"]').attr('on', state);

		this.updateGoogleGrants(cookieName, state);
	},

	updateGoogleGrants(cookieName, state) {

		const granted = state === 1 ? 'granted' : 'denied';

		if (cookieName === 'CookieFunctional') {
			gtag('consent', 'update', {
				'functionality_storage': granted,
			});
		}

		if (cookieName === 'CookieAnalytical') {
			gtag('consent', 'update', {
				'analytics_storage': granted,
			});
		}

		if (cookieName === 'CookieMarketing') {
			gtag('consent', 'update', {
				'ad_storage': granted,
				'ad_user_data': granted,
				'ad_personalization': granted,
			});
		}
	},

	acceptEssentialCookies() {
		Object.keys(this.consent).forEach((key) => {
			this.setConsent(key, this.essential.includes(key) ? 1 : 0);
		});
		this.cookiesSave(this.consent);
		this.checkStatus();

		gtag('consent', 'update', {
			'functionality_storage': 'granted',
			'analytics_storage': 'granted',
		});
	},

	acceptAllCookies() {
		Object.keys(this.consent).forEach((key) => {
			this.setConsent(key, 1);
		});
		this.cookiesSave(this.consent);
		this.checkStatus();

		gtag('consent', 'update', {
			'functionality_storage': 'granted',
			'analytics_storage': 'granted',
			'ad_storage': 'granted',
			'ad_user_data': 'granted',
			'ad_personalization': 'granted',
		});
	},

	resetCookies() {
		Object.keys(this.consent).forEach((key) => {
			this.setConsent(key, this.reset.includes(key) ? 0 : 1);
		});
		Cookie.remove(this.cookieName);
		this.checkStatus();

		gtag('consent', 'update', {
			'functionality_storage': 'denied',
			'analytics_storage': 'denied',
			'ad_storage': 'denied',
			'ad_user_data': 'denied',
			'ad_personalization': 'denied',
		});
	},

	getCookiesKey() {
		const cookie = Cookie.get(this.cookieName);
		if (cookie !== undefined && cookie !== '') {
			const cookies = JSON.parse(cookie.toString());
			return cookies.key;
		}
		return this.makeCode(32);
	},

	cookiesSave(consent, reload) {
		reload = (typeof reload !== 'undefined') ? reload : false;
		const key = this.getCookiesKey();
		const obj = { consent: consent, key: key, timestamp: Date.now(), version: this.version };
		const value = JSON.stringify(obj);
		const expires = new Date();
		expires.setFullYear(expires.getFullYear() + 1);
		Cookie.set(this.cookieName, value, expires);

		$.ajax({
			type: 'POST',
			url: WEB_ROOT + '/modules/cookies/cookies.async.php',
			data: obj,
			dataType: 'html',
			success: function(result) {
				if (reload) {
					location.reload();
				}
			},
		});
	},

	makeCode(length) {
		var result = '';
		var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		var charactersLength = characters.length;
		for (var i = 0; i < length; i++) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
		}
		return result;
	},
};

export default CookiesPage;
